import React from 'react';
import { useSelector } from 'react-redux';
import {getCruisesInfo} from "../utils/cruiseUtils";
import {formatItineraryDepartDate} from "../utils/dateTimeUtils";
import ThemableSvgIcon from "./theme/ThemableSvgIcon";
import { Plural, Trans } from '@lingui/react/macro';
import { getExcursionsText } from '../utils/themeUtils';

function CruisesItineraryInfo(props) {
    const cruises = useSelector(state => state.cruises ? state.cruises.cruiseDetails : null);
    const cruisesInfo = getCruisesInfo(cruises);

    return (
        <div className="bg-primary-lightest-25 shadow p-4 xl:grow">

            {/* cruise name */}
            <div className="text-3xl text-primary-dark font-bold mb-4">{cruisesInfo.cruiseName}</div>

            <div className="sm:flex md:block">

                {/* cruise info */}
                <div className="border-b border-primary-dark pb-4 sm:border-b-0 sm:border-r sm:w-1/2 sm:pr-4 md:border-b md:border-r-0 md:w-full md:pr-0">
                    <div className="flex items-center mb-2">
                        <ThemableSvgIcon name="ship" className="w-4 h-4 mr-2 inline shrink-0 text-primary-dark" alt="ship icon" />
                        <span>
                            <Trans id="sailing_on">Sailing on</Trans> {cruisesInfo.shipName}
                        </span>
                    </div>

                    <div className="flex items-center mb-2">
                        <ThemableSvgIcon name="calendar" className="w-4 h-4 mr-2 inline shrink-0 text-primary-dark" alt="calendar icon" />
                        <span>
                            <Trans id="departs">Departs</Trans> {formatItineraryDepartDate(cruisesInfo.cruiseStart)}
                        </span>
                    </div>
                    <div className="flex items-center mb-2">
                        <ThemableSvgIcon name="moon" className="w-4 h-4 mr-2 inline shrink-0 text-primary-dark" alt="moon icon" />
                        <span>
                            {cruisesInfo.cruiseDuration} <Trans id='nights_cruise'>nights cruise</Trans>
                        </span>
                    </div>
                </div>

                {/* nrExcursions and nrRestaurants */}
                <div className="mt-4 sm:mt-0 sm:w-1/2 sm:pl-4 md:mt-4 md:w-full md:pl-0">
                    <div className="mb-2">
                        <Trans id="plan_your_cruise_text">Plan your {getExcursionsText(true)} by choosing from:</Trans>
                    </div>
                    <ul className="list-square list-inside text-primary-dark">
                        <li className="mt-2">{props.nrExcursions} {getExcursionsText(true)}</li>
                        {(props.nrRestaurants > 0) &&
                            <li className="mt-2">
                                <Plural
                                    id="speciality_restaurant"
                                    value={props.nrRestaurants}
                                    one="# speciality restaurant"
                                    other="# speciality restaurants"
                                />
                            </li>
                        }
                        {(props.nrActivities > 0) &&
                            <li className="mt-2">
                                <Plural
                                    id="activity"
                                    value={props.nrActivities}
                                    one="# activity"
                                    other="# activities"
                                />
                            </li>
                        }
                    </ul>
                </div>
            </div>

        </div>
    );
}

export default CruisesItineraryInfo;
